// extracted by mini-css-extract-plugin
export default {"breadcrumbItem":"breadCrumb_breadcrumbItem__QT9aJ","breadcrumbItemSelected":"breadCrumb_breadcrumbItemSelected__N4ZZc"};